import {Injectable} from '@angular/core';
import * as CryptoJS from 'crypto-js';

const key = 'MIGTAgEAMBMGByqGSM49AgEGCCqGSM49AwEHBHkwdwIBAQQgzimjOma9z5sBV4w+4jVrtcLpjKhB4j58ThV708Yn5wKgCgYIKoZIzj0DAQehRANCAAT30OTC2Ziq0yaAyCEuobF9OUatmoDMsVrT2E/q8PwPO7WsoH2mtJGm3GxQ/eXq06CJwAGJ8TuAzsKBfk0zqgiv';
const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
const iv = CryptoJS.enc.Base64.parse(key);

@Injectable({
    providedIn: 'root'
})
export class CryptoService {

    public encrypt (msg: string): string {
        const enc = CryptoJS.AES.encrypt(msg, keyUtf8, { iv: iv });
        const encStr = enc.toString();
        return encStr;
    }

    public decrypt (msgEnc: string): string {
        const dec = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(msgEnc) }, keyUtf8, { iv: iv });
        const decStr = CryptoJS.enc.Utf8.stringify(dec);
        return decStr;
    }
}
